import React from 'react';
import { motion } from 'framer-motion';
export function UseCases() {
  const cases = [{
    title: 'Clinical documentation and ambient AI',
    desc: 'Read and write structured notes, summaries, and billing codes directly from the EHR.'
  }, {
    title: 'Prior auth, eligibility, and billing automation',
    desc: 'Automate clinical questionnaires, eligibility checks, and submissions to payers and clearinghouses.'
  }, {
    title: 'Care navigation and virtual care',
    desc: 'Surface the right care options, coordinate referrals, and support patients between visits.'
  }];
  return <section id="use-cases" className="py-24 relative z-10" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6" data-id="element-104">
        <div className="mb-16" data-id="element-105">
          <span className="text-hubble-accent text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-106">
            USE CASES
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-text mb-6" data-id="element-107">
            Built for the teams shaping healthcare AI.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-hubble-body max-w-3xl leading-[1.6]" data-id="element-108">
            From clinical documentation to billing automation, Hubble powers the
            agents working across healthcare.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-109">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-primary/50 transition-colors" data-id="element-110">
              <h3 className="font-heading text-xl font-medium text-hubble-text mb-4" data-id="element-111">
                {item.title}
              </h3>
              <p className="font-body text-[16px] text-hubble-body leading-[1.6]" data-id="element-112">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}